const cardItems = [
  {
    title: '狂飙',
    category: '国产剧 · 扫黑',
    score: '9.8',
    desc: '张译、张颂文主演现象级扫黑剧，全员演技在线，剧情紧凑高能不断。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20intense%20atmosphere%2C%20dark%20urban%20night%20scene%20with%20two%20men%20in%20confrontation%2C%20cinematic%20lighting%20with%20warm%20and%20cool%20contrast%2C%20dramatic%20film%20poster%20style%2C%20professional%20photography%20quality%2C%20dark%20moody%20tones&width=800&height=450&seq=card-1-kuangbiao&orientation=landscape',
  },
  {
    title: '三体',
    category: '科幻 · 国产剧',
    score: '9.6',
    desc: '刘慈欣同名小说改编，硬核科幻巨制，视觉震撼直击心灵。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Science%20fiction%20drama%20poster%20with%20cosmic%20themes%2C%20deep%20space%20background%20with%20stars%20and%20galaxies%2C%20mysterious%20atmosphere%20with%20three%20suns%20concept%2C%20cinematic%20film%20poster%20design%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20epic%20scale%20visual&width=800&height=450&seq=card-2-threebody&orientation=landscape',
  },
  {
    title: '莲花楼',
    category: '古装 · 探案',
    score: '9.5',
    desc: '成毅领衔古装探案，江湖奇案层层反转，服化道精美绝伦。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20costume%20drama%20poster%20with%20traditional%20architecture%2C%20martial%20arts%20aesthetic%2C%20elegant%20Hanfu%20costumes%20in%20wind%2C%20ethereal%20atmosphere%20with%20lotus%20flowers%2C%20beautiful%20cinematic%20lighting%2C%20traditional%20Chinese%20painting%20style&width=800&height=450&seq=card-3-lotus&orientation=landscape',
  },
  {
    title: '封神第一部',
    category: '电影 · 奇幻',
    score: '9.4',
    desc: '史诗级神话巨制，顶级视效还原封神演义，大银幕级震撼体验。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20film%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20dramatic%20battle%20scene%20silhouette%2C%20golden%20and%20crimson%20color%20palette%2C%20grand%20scale%20cinematic%20composition%2C%20majestic%20and%20powerful%20visual%20style&width=800&height=450&seq=card-4-fengshen&orientation=landscape',
  },
  {
    title: '漫长的季节',
    category: '国产剧 · 悬疑',
    score: '9.7',
    desc: '范伟、秦昊主演，跨越二十年的悬疑故事，口碑封神之作。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Atmospheric%20suspense%20drama%20poster%20with%20nostalgic%20northern%20Chinese%20industrial%20town%20setting%2C%20autumn%20leaves%20and%20golden%20light%2C%20mysterious%20and%20melancholic%20mood%2C%20cinematic%20film%20poster%20aesthetic%2C%20warm%20amber%20and%20deep%20shadows&width=800&height=450&seq=card-5-longseason&orientation=landscape',
  },
  {
    title: '长相思',
    category: '古装 · 爱情',
    score: '9.3',
    desc: '杨紫领衔古装仙侠，三世虐恋荡气回肠，服化造景美到极致。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20fantasy%20drama%20poster%20with%20ethereal%20beauty%2C%20flowing%20silk%20fabrics%20and%20cherry%20blossoms%2C%20dreamy%20misty%20landscape%20with%20ancient%20pavilions%2C%20soft%20pink%20and%20gold%20color%20tones%2C%20poetic%20and%20elegant%20cinematic%20style&width=800&height=450&seq=card-6-lovesickness&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              高分好剧一网打尽，每一部都值得看
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {cardItems.map((item) => (
              <div
                key={item.title}
                className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={item.imgUrl}
                    alt={`${item.title} - 高清免费观看`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                    <span className="flex items-center gap-1 text-sm font-bold text-accent-600">
                      <i className="ri-star-fill text-xs"></i>
                      {item.score}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mb-2">{item.category}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}